// PMD Liquor — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── DESCRIPTION TOGGLE ───────────────────────────────────────────────
  window.toggleDesc = function(btn) {
    const desc = btn.nextElementSibling;
    const isOpen = desc.style.display !== 'none';
    desc.style.display = isOpen ? 'none' : 'block';
    btn.classList.toggle('open', !isOpen);
  };

  // ── QTY BUTTONS ──────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.matches('.qty-btn-minus')) {
      const input = e.target.closest('.qty-wrap').querySelector('.qty-input');
      const moq = parseInt(input.dataset.moq) || 1;
      const min = parseInt(input.min) || moq;
      const newVal = parseInt(input.value) - moq;
      input.value = Math.max(min, newVal);
    }
    if (e.target.matches('.qty-btn-plus')) {
      const input = e.target.closest('.qty-wrap').querySelector('.qty-input');
      const moq = parseInt(input.dataset.moq) || 1;
      const max = parseInt(input.max) || 99999;
      const newVal = parseInt(input.value) + moq;
      input.value = Math.min(max, newVal);
    }
  });

  // ── AJAX ADD TO CART ─────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('.add-to-cart-form')) return;
    e.preventDefault();

    const btn = form.querySelector('.btn-add');
    const variantId = form.querySelector('input[name="id"]').value;
    const qty = parseInt(form.querySelector('.qty-input').value) || 1;
    const originalText = btn.textContent;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(res => res.json())
    .then(data => {
      if (data.status) {
        showToast(data.description || 'Could not add to cart');
        btn.textContent = originalText;
        btn.disabled = false;
        return;
      }
      // Update cart count
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const badge = document.getElementById('cart-count');
          if (badge) badge.textContent = cart.item_count;
        });

      btn.textContent = '✓ Added';
      btn.style.background = 'var(--black-5)';
      btn.style.color = 'var(--gold)';
      showToast(data.product_title + ' added to order');

      // Open cart drawer
      if (window.onCartAdded) window.onCartAdded();

      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 1800);
    })
    .catch(() => {
      showToast('Something went wrong — please try again');
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });

  // ── TOAST ─────────────────────────────────────────────────────────────
  window.showToast = function (msg) {
    let wrap = document.getElementById('pmd-toast');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'pmd-toast';
      wrap.className = 'toast-wrap';
      wrap.innerHTML = '<div class="toast-inner"></div>';
      document.body.appendChild(wrap);
    }
    wrap.querySelector('.toast-inner').textContent = msg;
    wrap.classList.add('visible');
    clearTimeout(wrap._t);
    wrap._t = setTimeout(() => wrap.classList.remove('visible'), 2800);
  };

  // ── FLASH MESSAGES ─────────────────────────────────────────────────
  const flash = document.querySelector('[data-flash]');
  if (flash) showToast(flash.dataset.flash);

  // ── ACTIVE NAV ──────────────────────────────────────────────────────
  const currentPath = window.location.pathname;
  document.querySelectorAll('.sidebar-link').forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

});
